import {CC_CONTRACT_DETAILS, CC_SURVEY_DETAILS} from '@cc-commons/cc-routing-roots';

export const CCSPO_DASHBOARD = 'dashboard';
export const CCSPO_CONTRACTS_LIST = 'contracts';
export const CCSPO_CONTRACT_DETAILS = CC_CONTRACT_DETAILS;
export const CCSPO_SURVEY_DETAILS_SPOT = CC_SURVEY_DETAILS;
export const CCSPO_APPOINTMENTS_LIST = 'appointments';
export const CCSPO_APPOINTMENTS_DETAILS = 'details';
export const CCSPO_APPOINTMENT_SPOT = 'appointment-spot';
export const CCSPO_CONTACTS_LIST = 'contact';
